export default {"src":"/_next/static/media/G.02543e33.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};